module.exports = __webpack_public_path__ + "static/desk-39a9cc791503b2fc8cdd987f2bcfe33d.jpg";